<template>
  <header class="hero-banner text-white d-flex align-items-center justify-content-center text-center tech-gradient-bg" id="inicio">
    <div class="container py-5 py-md-5">
      <div class="row justify-content-center">
        <div class="col-lg-10">
          
          <div class="mb-4 animate__fadeInDown animate__delay-0s">
            <i class="bi bi-cpu-fill hero-icon animated-icon-spin"></i>
          </div>

          <h1 class="display-2 fw-bolder mb-3 banner-title animate__fadeInUp animate__delay-1s">
            Briantisman Compuservicio
          </h1>

          <h2 class="lead-lg fw-bold mb-4 text-shadow-lg animate__fadeInUp animate__delay-1-5s">
            Soluciones Técnicas Expertas para tu Equipo
          </h2>

          <p class="lead mb-5 text-shadow-sm animate__fadeInUp animate__delay-2s">
            Reparamos, optimizamos y te asesoramos para que tu tecnología nunca se detenga. 
            **¡Rápido, confiable y con garantía!**
          </p>

          <a href="#contacto" class="btn btn-primary btn-lg banner-btn-glow animate__bounceIn animate__delay-3s">
            <i class="bi bi-rocket-takeoff-fill me-2"></i>
            ¡Quiero Reparar Mi Equipo Ahora!
          </a>
          
          <div class="mt-5 d-none d-md-block text-white-50 animate__fadeInUp animate__delay-3-5s">
            <i class="bi bi-shield-fill-check me-3 fs-4 text-success-light" title="Garantía Certificada"></i>
            <i class="bi bi-lightning-charge-fill me-3 fs-4 text-warning-light" title="Servicio Rápido"></i>
            <i class="bi bi-tools fs-4 text-info-light" title="Experiencia Técnica"></i>
          </div>

        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: "HeroBanner",
};
</script>

<style scoped>
/* IMPORTANTE: Requiere Animate.css para las clases 'animate__' */

/* === Sección General === */
.hero-banner {
  background-color: #0d0d10; /* Color base casi negro */
  min-height: 90vh; /* Aumentamos la altura para más presencia */
  position: relative;
  overflow: hidden;
  box-shadow: inset 0 0 100px rgba(0, 0, 0, 0.9);
}

/* === Fondo Sofisticado (Más intenso) === */
.tech-gradient-bg {
    /* 1. Degradado Radial para enfocar el centro y dar profundidad */
    background-image: 
        radial-gradient(ellipse at center, rgba(13, 110, 253, 0.1) 0%, rgba(13, 13, 16, 1) 75%),
        /* 2. Patrón de Líneas Tenue para el toque tecnológico */
        linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
    background-size: 100% 100%, 35px 35px, 35px 35px; /* Líneas más grandes y visibles */
}

/* === Título con Efecto de Glow (Más Potente) === */
.banner-title {
  color: #ffffff;
  /* Glow más potente y azul neón */
  text-shadow: 0 0 30px rgba(13, 110, 253, 1.5), 0 0 50px rgba(13, 110, 253, 1.0);
  animation: titleGlow 4s infinite alternate ease-in-out; /* Animación más lenta */
  line-height: 1.1;
}

@keyframes titleGlow {
  0% { text-shadow: 0 0 15px rgba(13, 110, 253, 1.0); }
  100% { text-shadow: 0 0 30px rgba(13, 110, 253, 1.5); }
}

/* === Subtítulos === */
.lead-lg {
    font-size: 1.8rem;
    color: #f1f1f1;
}

.text-shadow-lg {
    text-shadow: 0 0 10px rgba(0, 0, 0, 1);
}

.text-shadow-sm {
  text-shadow: 0 0 5px rgba(0, 0, 0, 0.7);
}

/* === Ícono Grande y Animado === */
.hero-icon {
  font-size: 6rem; /* Más grande */
  color: #0d6efd; 
  text-shadow: 0 0 20px rgba(13, 110, 253, 1.5); /* Más glow */
  display: block;
}

/* Combinamos pulse y spin para un efecto más dinámico */
.animated-icon-spin {
    animation: pulse 1s infinite ease-in-out, spin 6s linear infinite; 
}
@keyframes pulse {
  0% { transform: scale(1) rotate(0deg); opacity: 0.95; }
  50% { transform: scale(1.03) rotate(10deg); opacity: 1; }
  100% { transform: scale(1) rotate(0deg); opacity: 0.95; }
}
@keyframes spin {
    to { transform: rotate(360deg); }
}

/* === Botón Principal (Glow más intenso) === */
.banner-btn-glow {
  background-color: #0d6efd;
  border-color: #0d6efd;
  font-weight: 700;
  border-radius: 12px;
  transition: 0.3s ease-in-out;
  /* Glow más fuerte por defecto */
  box-shadow: 0 0 15px rgba(13, 110, 253, 1.2), 0 5px 20px rgba(0, 0, 0, 0.7); 
}

.banner-btn-glow:hover {
  background-color: #0b5ed7;
  border-color: #0b5ed7;
  transform: translateY(-8px) scale(1.08); /* Movimiento más dramático */
  /* El glow se intensifica mucho en el hover */
  box-shadow: 0 0 40px rgba(13, 110, 253, 2.5), 0 10px 30px rgba(0, 0, 0, 0.9); 
}

/* === Estilos de Íconos de Valor Añadido === */
.text-success-light { color: #25d366; }
.text-warning-light { color: #ffc107; }
.text-info-light { color: #0dcaf0; }


/* === Animaciones de Entrada (Retardos Afinados) === */
.animate__delay-0s { animation-delay: 0.0s; } /* Ícono */
.animate__delay-1s { animation-delay: 0.4s; } /* Título (Briantisman Compuservicio) */
.animate__delay-1-5s { animation-delay: 0.8s; } /* Subtítulo 1 */
.animate__delay-2s { animation-delay: 1.2s; } /* Subtítulo 2 */
.animate__delay-3s { 
  animation-delay: 1.6s; /* Botón */
  animation-duration: 1s; 
}
.animate__delay-3-5s { animation-delay: 2.0s; } /* Íconos de valor añadido */

/* === Optimización para Teléfonos (Móvil) === */
@media (max-width: 767.98px) {
  .hero-banner {
    min-height: 80vh; 
  }
  .hero-icon {
    font-size: 5rem; 
  }
  .banner-title {
    font-size: 2.5rem; 
    margin-bottom: 1rem !important;
  }
  .lead-lg {
      font-size: 1.3rem;
  }
  .lead {
    font-size: 0.95rem; 
    margin-bottom: 2rem !important;
  }
  .banner-btn-glow {
    width: 90%; 
    font-size: 1rem;
    padding: 0.75rem 1.5rem;
  }
}
</style>